// extracted by mini-css-extract-plugin
module.exports = {"overlay":"BaseLoading_overlay__1726a"};